import { TypeOffre } from '@/enum/TypeOffre'
import { ExportCatalogType } from '@/enum/ExportCatalogType'


export interface AloBase {
    id:number
    libelle:string
}

export const getDefaultAloBase = ():AloBase => {
    return {
        id:0,
        libelle:''
    }
}